// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DedBH","footer":"styles_footer__2xjnh","passCodeTooltip":"styles_passCodeTooltip__1Dru9"};